
enum TradingModalType {

    // IFrame based
    Deposit = "deposit",
    KYC = "kyc",
    Professional = "professional",
    Documents = "documents",
    DepositLimits = "depositLimits",
    ShareInfo = "shareInfo",
    // Trade related
    AddSymbol = "addSymbol",
    CreateTrade = "createTrade",
    CreateEditTrade = "createEditTrade",
    CloseTrades = "closeTrades",
    ClosedTrade = "closedTrade",
    SetAlert = "setAlert",
    // Account related
    Withdrawal = "withdrawal",
    WithdrawalSuccess = "withdrawalSuccess",
    AccountStatements = "accountStatements",
    TransactionsHistory = "transactionsHistory",
    ChangePassword = "changePassword",
    CloseOutMethod = "closeOutMethod",
    MyLeverageDisclaimer = "myLeverageDisclaimer",
    MyLeverage = "myLeverage",
    ChangeName = "changeName",
    ChangeEmail = "changeEmail",
    ChangePhoneNumber = "changePhoneNumber",
    ChangeAddress = "changeAddress",
    SymbolSearch = "symbolSearch",
    Video = "Video",
    AcademyVideo = "AcademyVideo",
    SignalsDisclaimer = "SignalsDisclaimer",
    Support = "Support",
    NotificationDetails = "NotificationDetails",
    // Promotions related
    EducationalTrades = "educationalTrades",
    RebatePlan = "rebatePlan",
    Vault = "vault",
    ProtectedPosition = "protectedPosition",
    SpreadCashback = "spreadCashback",
    InsurancePosition = "insurancePosition",
    RollingContract = "rollingContract",
    RollOverDiscount = "rollOverDiscount",
    CreditPromo = "creditPromo",
    Feedback = "feedback",
}
export default TradingModalType;
